import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'app/app.constants';
import { createRequestOption } from 'app/shared/util/request-util';
import { IFileObject } from '../../shared/model/file-object.model';
// import { IDoctor } from '../../shared/model/doctor.model';
import { map } from 'rxjs/operators';

type EntityResponseType = HttpResponse<IFileObject>;
type EntityArrayResponseType = HttpResponse<IFileObject[]>;

@Injectable({ providedIn: 'root' })
export class FileObjectService {
  public resourceUrl = SERVER_API_URL + 'api/files';
  public resourceUrlForAll = SERVER_API_URL + 'api/files-website';
  public resourceUrl_profile = SERVER_API_URL + 'api/files/profile';
  public resourceUrl_meeting = SERVER_API_URL + 'api/files/meeting';
  public resourceUrl_meetingAll = SERVER_API_URL + 'api/files/meeting-website';
  public resourceUrl_user_profile = SERVER_API_URL + 'api/files/profile/user';
  public resourceUrl_patient = SERVER_API_URL + 'api/files/patient';
  public resourceUrl_doctor = SERVER_API_URL + 'api/files/doctor';

  constructor(protected http: HttpClient) {}

  create(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.post<IFileObject>(this.resourceUrl, fileObject, { observe: 'response' });
  }

  createForPrjFactor(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.post<IFileObject>(this.resourceUrl+'-project-factor', fileObject, { observe: 'response' });
  }

  updateForPrjFactor(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.put<IFileObject>(this.resourceUrl+'-project-factor', fileObject, { observe: 'response' });
  }

  updateForPrjFactorEdit(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.put<IFileObject>(this.resourceUrl+'-project-factor-edit', fileObject, { observe: 'response' });
  }


  createProfileImg(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.post<IFileObject>(this.resourceUrl+'-profile-image', fileObject, { observe: 'response' });
  }

  createForAll(fileObject: IFileObject, token: any): Observable<EntityResponseType> {
    return this.http.post<IFileObject>(this.resourceUrl+'-website/' +token, fileObject, { observe: 'response' });
  }

  update(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.put<IFileObject>(this.resourceUrl, fileObject, { observe: 'response' });
  }

  updateProfile(fileObject: IFileObject): Observable<EntityResponseType> {
    return this.http.put<IFileObject>(this.resourceUrl +'/profile', fileObject, { observe: 'response' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IFileObject>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  findForAll(id: number, token: any): Observable<EntityResponseType> {
    return this.http.get<IFileObject>(`${this.resourceUrlForAll}/${id}` +'/' +token, { observe: 'response' });
  }

  // getDownloadUrl(id): Observable<Response> {
  //   // const options: BaseRequestOptions = new BaseRequestOptions();
  //   // const params: URLSearchParams = new URLSearchParams();
  //   // params.set('id', id);
  //   // options.params = params;
  //   return this.http.get(SERVER_API_URL + 'api/employee-files-downloadUrl', options).map((res) => { return res; })
  // }
  //
  // findImg(id: number): Observable<EntityResponseType> {
  //   return this.http.get<IFileObject>(`${this.resourceUrl_profile}/${id}`, { observe: 'response' });
  // }

  findImg(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_profile, { params: options, observe: 'response' });
  }


  find2(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IFileObject>(`${this.resourceUrl}/${id}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.dateOfBirth = res.body.dateOfBirth != null ? moment(res.body.dateOfBirth) : null;
    }
    return res;
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl, { params: options, observe: 'response' });
  }
  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl+'-search', { params: options, observe: 'response' });
  }
  getAllFilesWithoutImgProfile(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl+'-without-img-profile', { params: options, observe: 'response' });
  }


  // noinspection JSAnnotator
  // findWithCustomerId(req?: any, id: number): Observable<EntityArrayResponseType> {
  //   // const options = createRequestOption(req);
  //   return this.http
  //     .get<IFileObject[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateFromServer(res)));
  // }


  findWithCustomerId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-customer/'+id, {params: options, observe: 'response'});
  }

  findWithProjectId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-project/'+id, {params: options, observe: 'response'});
  }

  findWithFactorId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-factor/'+id, {params: options, observe: 'response'});
  }

  findWithFactorIdAndType(req?: any, id?:any, type?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-factor-type/'+id+'/'+type, {params: options, observe: 'response'});
  }
  findWithTicketId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-ticket/'+id, {params: options, observe: 'response'});
  }
  findWithTransactionId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-transaction/'+id, {params: options, observe: 'response'});
  }
  findWithOrderId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-order/'+id, {params: options, observe: 'response'});
  }
  findWithOrderBuyId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-order-buy/'+id, {params: options, observe: 'response'});
  }
  findWithContractId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-contract/'+id, {params: options, observe: 'response'});
  }
  findWithSalesCycleId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl + '-sales-cycle/'+id, {params: options, observe: 'response'});
  }

  getDownloadUrl(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl, { params: options, observe: 'response' });
  }


  queryPatient(req?: any,id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_patient+'/'+id, { params: options, observe: 'response' });
  }

  queryDoctor(req?: any,id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_doctor+'/'+id, { params: options, observe: 'response' });
  }

  queryProfile(req?: any,id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_profile+'/'+id, { params: options, observe: 'response' });
  }

  queryProfileCheck(req?: any,id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_profile+'-check/'+id, { params: options, observe: 'response' });
  }

  queryMeeting(req?: any,id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_meeting+'/'+id, { params: options, observe: 'response' });
  }

  queryMeetingForAll(req?: any,id?: any,token?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_meetingAll+'/'+id+'/'+token, { params: options, observe: 'response' });
  }

  queryUserProfile(req?: any,id?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IFileObject[]>(this.resourceUrl_user_profile+'/'+id, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }


  // getDownloadUrl(id): Observable<Response> {
  //   // const options: BaseRequestOptions = new BaseRequestOptions();
  //   // const params: URLSearchParams = new URLSearchParams();
  //   // params.set('id', id);
  //   // options.params = params;
  //   // return this.http.get(SERVER_API_URL + 'api/employee-files-downloadUrl', options).map((res) => { return res; })
  // }
}
